import { Fragment, memo } from 'react';

import { InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';
import MarketingCampaignActivityContent from '../../../shared/MarketingCampaignActivityContent';

import ActivityDetailContainer from '../ActivityDetailContainer';

const MarketingCampaignGeneralDetail = memo(({ activity, labels, shared }) => {
    const { rightContent, titleRow } = shared;
    const campaignName = activity?.Campaign?.Name;

    if (!activity?.Campaign) return null;

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                main: campaignName && (
                    <InfoRowSection>
                        <InfoRow label={labels.campaign} value={campaignName} />
                    </InfoRowSection>
                ),
                right: (
                    <Fragment>
                        {titleRow}
                        <MarketingCampaignActivityContent
                            campaign={activity.Campaign}
                            recipientsRightContent={rightContent}
                            variant="detail"
                        />
                    </Fragment>
                ),
            }}
        />
    );
});

MarketingCampaignGeneralDetail.displayName = 'MarketingCampaignGeneralDetail';

export default MarketingCampaignGeneralDetail;
